<article [className]="baseCardRecipe()" (click)="cardClick.emit()">
  <div [className]="cardBodyRecipeClass">
    @if (image) {
      <figure
        [className]="cardImageRecipeClass"
        (click)="imageClick.emit()"
        [ngStyle]="{
          backgroundImage: imageAsBackground ? 'url(' + image + ')' : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }"
      >
        @if (!imageAsBackground) {
          <img [src]="image" />
        }
      </figure>
    }
    @if (progress != undefined) {
      <div class="video-progress">
        <div
          class="progress-bar progress-indicator"
          role="progressbar"
          [ngStyle]="{ width: progress + '%' }"
          attr.aria-valuenow="{{ progress }}"
          aria-valuemin="0"
          aria-valuemax="100"
          aria-busy="false"
          [attr.aria-label]="title + ' progress: '"
        ></div>
      </div>
    }
    <section [className]="cardContentRecipe()">
      <span class="card-title" (click)="titleClick.emit()">{{ title }}</span>
      @if (text) {
        <div [className]="baseCardDescriptionRecipe()">{{ text }}</div>
      }
      <ng-content></ng-content>
    </section>
  </div>
</article>
